import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

const UserRoute = ({ isAuthenticated, component: Component, ...rest }) => (
  <Route {...rest} render={props => (isAuthenticated ? <Component {...props} /> : <Redirect to="/admin/login" />)} />
);

UserRoute.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = state => {
  return {
    isAuthenticated: !!state.auth.loggedUserToken,
  };
};

export default connect(mapStateToProps)(UserRoute);
